export default class SearchEventManager {
	on(eventName, handler, forceEarly) {
		this.extensions = this.extensions || {};

		if (!this.extensions[eventName]) {
			this.extensions[eventName] = [];
		}

		const handlerData = {
			action: handler,
			forceEarly: forceEarly ? true : false,
		};

		this.extensions[eventName].push(handlerData);
	}

	off(eventName, handler) {
		if (!this.extensions) {
			return;
		}

		const handlers = this.extensions[eventName];

		if (!handlers) {
			return;
		}

		for (let i = 0; i < handlers.length; i++) {
			if (handlers[i] === handler) {
				handlers.splice(i--, 1);
			}
		}
	}

	trigger(eventName, ...args) {
		if (!this.extensions || !this.extensions[eventName]) {
			return;
		}

		this.executeEarlyListeners(eventName, args);
		this.executeLateListeners(eventName, args);
	}

	executeEarlyListeners(eventName, ...args) {
		this.extensions[eventName]
			.filter((extension) => {
				return extension.forceEarly;
			})
			.forEach((handler) => handler.action.apply(this, ...args));
	}

	executeLateListeners(eventName, ...args) {
		this.extensions[eventName]
			.filter((extension) => {
				return !extension.forceEarly;
			})
			.forEach((handler) => handler.action.apply(this, ...args));
	}
}
